'use strict';

angular.module('ntmApp').factory('NtmCalendar', ['calendarConfig', '$rootScope', '$q', '$timeout', 'CalendarService', 'Utils', 'CalendarFilters', 'ComplexSearchConstants', 'CalendarDataProperty', 'CalendarDataService', 'FlashService', 'ElementIdHelper',
    function (calendarConfig, $rootScope, $q, $timeout, CalendarService, Utils, CalendarFilters, ComplexSearchConstants, CalendarDataProperty, CalendarDataService, FlashService, ElementIdHelper) {

        function NtmCalendar(appOptId) {

            var self = this;

            var eventList = [];

            self.calendarFilters = new CalendarFilters(appOptId);

            self.LoadConfig = function () {
            
                self.isLoading = true;
                FlashService.ShowProgressBar();

                var deferred = $q.defer();

                self.viewDate = moment();

                self.calendarFilters.loadFilters().then(function () {

                    CalendarService.GetCalendar(appOptId).then(function (result) {

                        if (result.success) {

                            prepareData(result.data);
                        }

                        deferred.resolve();
                        self.isLoading = false;
                        FlashService.HideProgressBar();
                    });
                });

                return deferred.promise;
            };

            self.ReloadCalendarData = function () {
                self.isLoading = true;
                FlashService.ShowProgressBar();

                var deferred = $q.defer();

                CalendarService.GetCalendar(appOptId).then(function (result) {

                    if (result.success) {
                        prepareData(result.data);
                    }

                    deferred.resolve();
                    self.isLoading = false;
                    FlashService.HideProgressBar();
                });

                return deferred.promise;
            };

            self.viewChangeClicked = function (date, nextView) {

                if (date || nextView) {
                }

                return !!self.useViewNavigationLinks;
            };

            self.getCurrentDate = function () {
                return moment(self.calendarTitle).format('YYYY-MM-DD');
            };

            self.onEventTimeChanged = function (event, calendarNewEventStart, calendarNewEventEnd) {
                event.startsAt = calendarNewEventStart;
                event.endsAt = calendarNewEventEnd;
            };

            self.SetViewMode = function (viewMode) {
                self.calendarView = mapViewMode(viewMode);
                self.cellIsOpen = false;
            };

            self.GetConfiguredViewName = function () {

                if (self.calendarView.value === 'day') {
                    return calendarConfig.showTimesOnWeekView ? 'AgendaDayView' : 'day';
                }

                if (self.calendarView.value === 'week') {
                    return calendarConfig.showTimesOnWeekView ? 'AgendaWeekView' : 'week';
                }

                return self.calendarView.value;
            };

            self.onEventClicked = function (event, hasEventForm) {

                switch (event.performingAction) {
                    case 'SHOW_DIALOG':
                        if (event.eventList.length > 0) {
                            showMonthEventsDialog(event.eventList, event.day.date);
                        }
                        break;
                    case 'Show event form':
                        if (hasEventForm || event.hasEventForm) {
                            showCalendarEventForm(event.calendarEvent);
                        }
                        break;
                    case 'Show button dialog form':

                        if (event.calendarButton.isForm) {
                            showButtonDialogForm(event.calendarButton, event.clickedButtonsDate);
                        } else {
                            FlashService.Error('Configuration error: button dialog form not found', true);
                        }
                        break;
                }
            };

            self.calendarFilters.filterCallback = function (condition) {
                self.calendarFilters.performDependencies(condition);
                performFiltering();
            };

            $rootScope.$watch(function () {
                return self.selectedAggregate;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    self.calendarTemplateScope.selectedAggregate = null;

                    $timeout(function () {
                        self.calendarTemplateScope.selectedAggregate = newValue;
                    }, 5);
                }
            }, true);

            self.performGroupingEvents = function (calendarCell) {
                if (!self.selectedAggregate) {
                    self.calendarTemplateScope.groupedEvents = null;
                    self.calendarTemplateScope.selectedAggregate = null;

                    return;
                }
                
                for (var i = 0; i < calendarCell.events.length; i++) {
                    if (calendarCell.events[i].eventData.data[self.selectedAggregate.groupBy]) {
                        calendarCell.events[i][self.selectedAggregate.groupBy] = calendarCell.events[i].eventData.data[self.selectedAggregate.groupBy];
                    }
                }

                var groupedEvents = calendarCell.events.groupBy(self.selectedAggregate.groupBy);

                calendarCell.groupedEvents = [];
                groupedEvents.forEach(function (group) {
                    calendarCell.groupedEvents.push({ groupName: group.key, count: group.items.length, fieldsAndValuesObject: group.items[0].eventData.data });
                });
            };

            function getDailyAggregates(dailyAggregatesString, anyFieldsAndValuesObject) {
                var dailyAggregatesJSON = [];
                var filteredWithoutBadDailyAggregates = [];

                if (dailyAggregatesString !== null && dailyAggregatesString !== '') {
                    dailyAggregatesJSON = JSON.parse(dailyAggregatesString);

                    dailyAggregatesJSON.forEach(function (aggItem) {
                        if (aggItem.groupBy && aggItem.dropdown && anyFieldsAndValuesObject[aggItem.groupBy] !== undefined) {
                            filteredWithoutBadDailyAggregates.push(aggItem);
                        }
                    });
                }

                return filteredWithoutBadDailyAggregates;
            }

            function performFiltering() {

                var events = angular.copy(eventList);

                self.calendarFilters.getConditions().forEach(function (filter) {

                    if ((filter.value || (filter.from && filter.to)) && (!filter.hasOperators() || filter.hasOperators() && filter.selectedOperator)) {

                        events = events.filter(function (item) {

                            switch (filter.selectedFieldType.type) {
                                case ComplexSearchConstants.ControlTypes.TEXT:
                                    return item.data[filter.selectedFieldType.fieldName] && ((item.data[filter.selectedFieldType.fieldName]).toLowerCase()).indexOf((filter.value).toLowerCase()) !== -1;
                                case ComplexSearchConstants.ControlTypes.NUMERIC:
                                    switch (filter.selectedOperator.value) {
                                        case 'Equal':
                                            return item.data[filter.selectedFieldType.fieldName] === filter.value;
                                        case 'lessThanOrEquals':
                                            return item.data[filter.selectedFieldType.fieldName] <= filter.value;
                                        case 'GreaterThanOrEquals':
                                            return item.data[filter.selectedFieldType.fieldName] >= filter.value;
                                        case 'between':
                                            return ((item.data[filter.selectedFieldType.fieldName] >= filter.from) && (item.data[filter.selectedFieldType.fieldName] <= filter.to));
                                        default:
                                            return false;
                                    }
                                    break;
                                case ComplexSearchConstants.ControlTypes.CHECKBOX:
                                    return item.data[filter.selectedFieldType.fieldName] === true;
                                case ComplexSearchConstants.ControlTypes.PICKLIST:
                                case ComplexSearchConstants.ControlTypes.AUTOCOMPLETE:
                                    return item.data[filter.selectedFieldType.fieldName] === filter.value.id;
                                case ComplexSearchConstants.ControlTypes.DROPLIST:
                                    return item.data[filter.selectedFieldType.fieldName] === filter.value;
                                case ComplexSearchConstants.ControlTypes.CHECKBOXLIST:
                                    return filter.value.length === 0 ? true : filter.value.filter(function (i) {
                                        return item.data[filter.selectedFieldType.properties.key] === i.id;
                                    }).length > 0;
                                case ComplexSearchConstants.ControlTypes.DATE:
                                    switch (filter.selectedOperator.value) {
                                        case 'Equal':
                                            return (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isSame(moment(filter.value).startOf('day'));
                                        case 'lessThanOrEquals':
                                            return (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isSame(moment(filter.value).startOf('day')) || (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isBefore(moment(filter.value).startOf('day'));
                                        case 'GreaterThanOrEquals':
                                            return (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isSame(moment(filter.value).startOf('day')) || (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isAfter(moment(filter.value).startOf('day'));
                                        case 'between':
                                            return (((moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isSame(moment(filter.from).startOf('day')) ||
                                                   (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isAfter(moment(filter.from).startOf('day'))) &&
                                                   ((moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isSame(moment(filter.to).startOf('day')) ||
                                                   (moment(item.data[filter.selectedFieldType.fieldName]).startOf('day')).isBefore(moment(filter.to).startOf('day'))));
                                        default:
                                            return false;
                                    }
                                    break;
                                case ComplexSearchConstants.ControlTypes.RADIOBOOLEAN:
                                    return filter.value === 'Yes' ? item.data[filter.selectedFieldType.fieldName] === true : item.data[filter.selectedFieldType.fieldName] === false;
                                default:
                                    return false;
                            }
                        });
                    }
                });

                initEvents(events);
                
            }

            function prepareData(data) {
                self.SetViewMode(data.calendarDefaultView);

                self.calendarId = data.calendarId;
                self.eventFormHtmlPageId = data.eventFormHtmlPageId;
                self.title = data.calendarTitle;
                self.viewModes = (data.viewingOptions || []).map(mapViewMode);
                self.dayViewStart = data.agendaViewStart ? moment(data.agendaViewStart).format('HH:mm') : '';
                self.dayViewEnd = data.agendaViewEnd ? moment(data.agendaViewEnd).format('HH:mm') : '';
                self.useViewNavigationLinks = data.useViewNavigationLinks;
                self.dayViewMinutesSplit = data.agendaSlotDuration || 30;
                self.firstDayOfWeek = data.firstDayOfWeek;
                setFirstDayOfWeek(self.firstDayOfWeek);
                self.instructions = data.calendarInstructions;
                self.hasEventForm = data.isEventForm;
                self.calendarLevelButtons = data.calendarButtons.filter(function (calendarButton) { return calendarButton.level === 'calendar'; });
                self.dateLevelButtons = data.calendarButtons.filter(function (calendarButton) { return calendarButton.level === 'date'; });
                self.dailyAggregates = getDailyAggregates(data.dailyAggregates, data.event.eventsData.length > 0 ? data.event.eventsData[0].data : []);
                self.selectedAggregate = null;

                self.calendarTemplateScope = {};
                self.calendarTemplateScope.dateLevelButtons = self.dateLevelButtons;
                self.calendarTemplateScope.areThereValidDateLevelButtons = (self.dateLevelButtons.filter(function (dateLevelButton) { return dateLevelButton.name || dateLevelButton.icon; })).length > 0 ? true : false;

                self.calendarTemplateScope.selectedAggregate = null;
                self.calendarTemplateScope.groupedEvents = null;
                self.calendarTemplateScope.performGroupingEvents = self.performGroupingEvents;

                self.calendarTemplateScope.dateProperty = new CalendarDataProperty(data.dateProperty);
                self.calendarTemplateScope.eventsAreChanging = false;

                calendarConfig.dateFormatter = 'moment';
                calendarConfig.allDateFormats.moment.date.hour = 'HH:mm';
                calendarConfig.allDateFormats.moment.title.day = 'dddd MMMM D, YYYY';
                calendarConfig.allDateFormats.moment.title.week = getWeekLabel;

                calendarConfig.displayAllMonthEvents = true;
                calendarConfig.showTimesOnWeekView = data.useTimesOnWeekView;

                calendarConfig.templates.calendarMonthCell = 'ng1/src/calendar/templates/ntm-calendar-month-template.html';
                calendarConfig.templates.calendarWeekView = 'ng1/src/calendar/templates/ntm-calendar-week-view.html';
                calendarConfig.templates.calendarDayView = data.useTimesOnDayView ? 'ng1/src/calendar/templates/ntm-calendar-day-view.html' : 'ng1/src/calendar/templates/ntm-calendar-basic-day-view.html';
                calendarConfig.templates.calendarHourList = 'ng1/src/calendar/templates/ntm-calendar-hour-list.html';

                eventList = data.event.eventsData;
                initEvents(eventList);
                performFiltering();
            }

            function setFirstDayOfWeek(firstDayOfWeek) {
                moment.locale('en_gb', {
                    week: {
                        dow: firstDayOfWeek
                    }
                });
            }

            function showButtonDialogForm(clickedCalendarButton, clickedButtonsDate) {

                var data = {
                    calendarId: self.calendarId,
                    calendarButton: clickedCalendarButton,
                    clickedButtonsDate: clickedButtonsDate ? clickedButtonsDate : null,
                    updateMethod: self.ReloadCalendarData
                };

                var popup = Utils.OpenModal('', 'ng1/src/calendar/dialogs/dialogForm.html', 'calendarButtonDialogController', data, 'setup-open-modal-dialog calendar-button-dialog-form', null, false);

                popup.result.then(function () {
                    popup.dismiss();
                });
            }

            function showCalendarEventForm(calendarEvent) {

                var data = {
                    eventFormHtmlPageId: self.eventFormHtmlPageId,
                    calendarId: self.calendarId,
                    calendarEvent: calendarEvent,
                    updateMethod: self.ReloadCalendarData
                };

                var popup = Utils.OpenModal('', 'ng1/src/calendar/dialogs/dialogForm.html', 'eventFormDialogController', data, 'setup-open-modal-dialog calendar-event-form-dialog', null, false);

                popup.result.then(function () {
                    popup.dismiss();
                });
            }

            function showMonthEventsDialog(events, date) {

                if (events) {

                    var data = {
                        events: events,
                        date: date,
                        dateFormatter: calendarConfig.allDateFormats.moment.title.day,
                        onEventClicked: self.onEventClicked,
                        hasEventForm: self.hasEventForm
                    };

                    var popup = Utils.OpenModal('', 'ng1/src/calendar/dialogs/events-list-dialog.html', 'EventsDialogController', data, 'calendar-events-list-dialog', null, false);

                    popup.result.then(function () {
                        popup.dismiss();
                    });
                }
            }

            function initEvents(eventsData) {
                self.calendarTemplateScope.eventsAreChanging = true;

                self.events = (eventsData || []).map(function (event) {
                    return {
                        title: event.title,
                        cluetip: event.cluetip && event.cluetip.length > 0 ? event.cluetip : event.title,
                        startsAt: new Date(event.dateStart),
                        endsAt: CalendarDataService.GetEventEndDate(event.dateEnd),
                        isSingleDayEvent: ((!event.dateEnd) || ((moment(event.dateStart).startOf('day')).isSame(moment(event.dateEnd).startOf('day')))) ? true : false,
                        icons: event.icons ? event.icons.map(mapIcon) : null,
                        allDay: moment(event.dateStart).format('HH:mm') === '00:00',
                        pto: "PTO",
                        draggable: false,
                        resizable: false,
                        elementClassName: ElementIdHelper.getCalendarRecordElementClassName(self.calendarId, event.data),
                        eventData: event
                    };
                });

                self.pto = "PTO";

                $timeout(function () {
                    self.calendarTemplateScope.eventsAreChanging = false;
                }, 100);
            }

            function mapIcon(iconString) {

                if (iconString) {

                    var iconParts = iconString.split(';');

                    return {
                        icon: iconParts[0],
                        color: iconParts[1]
                    };
                }

                return null;
            }

            function mapViewMode(viewMode) {

                switch (viewMode) {
                    case "MonthView":
                    case "month":
                        return {
                            value: 'month',
                            calndarControlValue: 'month',
                            label: 'Month'
                        };
                    case "AgendaWeekView":
                        return {
                            value: 'AgendaWeekView',
                            calndarControlValue: 'week',
                            label: 'Week'
                        };
                    case "BasicWeekView":
                    case "week":
                        return {
                            value: 'week',
                            calndarControlValue: 'week',
                            label: 'Week'
                        };
                    case "AgendaDayView":
                        return {
                            value: 'AgendaDayView',
                            calndarControlValue: 'day',
                            label: 'Day'
                        };
                    case "BasicDayView":
                    case "day":
                        return {
                            value: 'day',
                            calndarControlValue: 'day',
                            label: 'Day'
                        };
                }

                return {
                };
            }

            function getWeekLabel(date) {
                var firstDay = moment(date).isoWeekday(0).startOf('day');
                var lastDay = moment(date).isoWeekday(6).startOf('day');

                if (firstDay.format('M') !== lastDay.format('M')) {

                    if (firstDay.format('YYYY') === lastDay.format('YYYY')) {
                        return '{0} {1} - {2} {3}, {4}'.format(firstDay.format('MMM'),
                                                                    firstDay.format('D'),
                                                                    lastDay.format('MMM'),
                                                                    lastDay.format('D'),
                                                                    lastDay.format('YYYY'));
                    }

                    return '{0} {1}, {2} - {3} {4}, {5}'.format(firstDay.format('MMM'),
                                    firstDay.format('D'),
                                    firstDay.format('YYYY'),
                                    lastDay.format('MMM'),
                                    lastDay.format('D'),
                                    lastDay.format('YYYY'));
                }

                return '{0} {1} - {2}, {3}'.format(firstDay.format('MMM'), firstDay.format('D'), lastDay.format('D'), lastDay.format('YYYY'));
            }

            function initialize() {
            }

            initialize();
        }

        return (NtmCalendar);
    }
]);
